/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualCreditDto } from '../../models/backend-actual-credit-dto';

export interface MonitoringActualsCreditsList$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
}

export function monitoringActualsCreditsList(
  http: HttpClient,
  rootUrl: string,
  params?: MonitoringActualsCreditsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendActualCreditDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsCreditsList.PATH, 'get');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendActualCreditDto>>;
    }),
  );
}

monitoringActualsCreditsList.PATH = '/api/monitoring/actuals/credits/';
